import React from 'react'

export default function Input(props) {
    return (
        <div class="relative w-full">
            {props.Icon &&
                <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                    {props.Icon}
                </div>
            }
            <input {...props} className={props.Icon ? (props.isError ? "pl-10 text-box-error" : "pl-10 text-box") : (props.isError ? "pl-4 text-box-error" : "pl-4 text-box")} />
        </div>
    )
}
